import { render, staticRenderFns } from "./TaskCardInfo.vue?vue&type=template&id=29264758"
import script from "./TaskCardInfo.vue?vue&type=script&lang=ts"
export * from "./TaskCardInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports